import React from "react";
import ISPV from "@market/components/SPVsList/ISPV";
import { MAIN_CURRENCY_LABEL } from "@bundles/consts";
import { SPVPriceChart } from "../SPVPriceChart";
import { Button } from "@appComponents/Button";
import { Link } from "react-router-dom";
import { MobileExpandedRow } from "@apps/MarketsApp/components/MobileExpandedRow";

type SPVMobileExpandedRowProps = {
  spv: ISPV;
  userSignedIn: boolean;
};

export const SPVMobileExpandedRow = ({
  spv,
  userSignedIn,
}: SPVMobileExpandedRowProps) => {
  const orderPageRoute = `/companies/${spv.company_slug}/market/spvs/${spv.id}/orders`;

  const rows = [
    {
      label: "COMPANY",
      content: spv.company_name || "-",
    },
    {
      label: "LAST PRICE",
      content: spv.last_trade_price
        ? `${Number(spv.last_trade_price).toFixed(
            2
          )} ${MAIN_CURRENCY_LABEL.toUpperCase()}`
        : "-",
    },
    {
      label: "LAST 7D",
      content:
        spv.id && spv.trading_asset_id ? (
          <SPVPriceChart
            spvId={spv.id}
            spvTradingAssetId={spv.trading_asset_id}
          />
        ) : (
          "-"
        ),
    },
    {
      label: "",
      content: (
        <Link
          to={
            userSignedIn
              ? orderPageRoute
              : `/users/sign_in?return_url=${orderPageRoute}`
          }
        >
          <Button isSmall isPrimary>
            Trade
          </Button>
        </Link>
      ),
    },
  ];

  return <MobileExpandedRow rows={rows} />;
};
